<template>
  <div id="digital-flop">

    <div class="digital-board" style="width:100%;">
      <div class="digital-board-title">
        {{locale('System Notice','系统公告')}}
      </div>
      <div class="digital-board-content">
        <table style="width:90%;">
          <tr>
            <td style="width:25%;" class="item_td">2020-06-15</td>
            <td style="width:70%;" class="item_td">最新能效标准GB18613-2020发布和解读</td>
          </tr>
          <tr>
            <td style="width:25%;" class="item_td">2020-06-05</td>
            <td style="width:70%;" class="item_td">上海市经济信息化委关于印发《上海市经济和信息化领域行政处罚裁量基准（节能执法类）》的通知</td>
          </tr>
          <tr>
            <td style="width:25%;" class="item_td">2019-11-25</td>
            <td style="width:70%;" class="item_td">关于组织开展年综合能耗2000-5000吨标煤工业企业保送2018年能源利用状况报告工作的通知</td>
          </tr>
        </table>
      </div>
      <div class="" style="width:100%;">
      <div class="digital-alarm-title">
        {{locale('Alert Message','警告信息')}}
      </div>
      <div class="digital-alarm-content">
        <table style="width:90%;">
          <tr>
            <td style="width:25%;" class="item_td"> </td>
            <td style="width:70%;" class="item_td"> </td>
          </tr>
          <tr>
            <td style="width:25%;" class="item_td"> </td>
            <td style="width:70%;" class="item_td"> </td>
          </tr>
          <tr>
            <td style="width:25%;" class="item_td"> </td>
            <td style="width:70%;" class="item_td"> </td>
          </tr>
        </table>
      </div>
    </div>

    </div>

    
    


  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'DigitalFlop',
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
  }
};
</script>

<style lang="less">
#digital-flop {
  position: relative;
  height: 100%;
  width: 100%;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #17293d;
  margin-left: 30px;

  .digital-board {
    position: absolute;;
    height: 30%;
    width: 100%;
    left: 0px;
    top: 0px;
    padding-top: 20px;
  }
  .digital-board-title {
    border-left: 5px solid #75E35E;
    padding-left: 30px;
    margin-bottom: 10px;
    font-size: 24px;
  }
  .digital-board-content {
    width: 100%;
  }
  .digital-board-item {
    width: 100%;
  }

  .item_td {
    border-bottom: 2px solid #3A4C7E;
    border-left-width: 0px;
    border-right-width: 0px;
    padding-left: 5px;
    height: 30px;
  }

  .digital-alarm {
    position: absolute;;
    height: 30%;
    width: 100%;
    left: 0px;
    top: 30%;
    padding-top: 20px;
  }
  .digital-alarm-title {
    border-left: 5px solid #F4E284;
    padding-left: 30px;
    margin-bottom: 10px;
    font-size: 24px;
  }
  .digital-alarm-content {
    width: 100%;
  }
  .digital-alarm-item {
    width: 100%;
  }
    
}
</style>
